// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    no-loop-func,
    no-return-assign,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import {CodonTranslationTable} from 'biojs/BioConstants';
import {
  ALL_CODONS,
  AMINO_ACID_TO_STANDARD_DNA_CODONS,
  STANDARD_DNA_CODE,
  StandardDNACodon,
} from 'biojs/Codons';
import * as util from 'biojs/Util';
import {Sequence} from 'components/Sequence';
import {HRTemplateColumn, TargetSite} from 'molbio/crispr/hr-template/HRTemplateStore';
import Tooltip from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {Optional} from 'util/Types';

// @ts-expect-error
import highlightMutant from './highlightMutant';
import HRTemplateActions from './HRTemplateActions';

interface Props {
  sequence: Sequence;
  pam: string;
  guide: string;
  targetSite?: TargetSite;
  columns: Array<HRTemplateColumn>;
  codonUsage?: Record<StandardDNACodon, number>;
}

class MutantTable extends React.Component<Props> {
  mutatedBases = (start: number, end: number): string =>
    // eslint-disable-next-line no-restricted-syntax
    _.pluck(this.props.columns, 'mutated')
      .join('')
      // eslint-disable-next-line no-restricted-syntax
      .slice(start - _.first(this.props.columns)!.start, end - _.first(this.props.columns)!.start);

  usageScore = (codon: StandardDNACodon): number | undefined =>
    this.props.codonUsage != null ? this.props.codonUsage[codon] : undefined;

  isSelected = (codon: StandardDNACodon, i: number): boolean => codon === this.props.columns[i].mutated;

  mutantRows = (
    columns: Array<HRTemplateColumn & {mutant?: StandardDNACodon}>
  ): Array<Array<(HRTemplateColumn & {mutant?: StandardDNACodon}) | null>> => {
    let i: number;
    const rows: Array<Array<(HRTemplateColumn & {mutant?: StandardDNACodon}) | null>> = [[]];
    columns = HRTemplateActions.demoteDegenerateCodingColumns(columns, this.props.sequence.bases(), false);
    for (i = 0; i < columns.length; i++) {
      const column = columns[i];
      if (!column.isCoding) {
        rows[0].push(column);
        continue;
      }

      const codon = this.props.sequence.residueSlice(column.start, column.end) as StandardDNACodon;
      assert(codon.length === 3, 'expected codon to have length 3');
      let j = 0;
      assert(ALL_CODONS.includes(codon.toUpperCase() as StandardDNACodon), 'Unexpected degenerate codon');
      const mutants =
        AMINO_ACID_TO_STANDARD_DNA_CODONS[STANDARD_DNA_CODE[codon.toUpperCase() as StandardDNACodon]];
      var score = this.usageScore(codon)!;
      for (const mutant of Array.from(
        _.sortBy(mutants, (mutant) => Math.abs(score - this.usageScore(mutant)!))
      )) {
        if (codon !== mutant) {
          if (rows[j] == null) {
            rows[j] = [];
          }
          while (rows[j].length < i) {
            rows[j].push(null);
          }
          const mutantCell = _.clone(column);
          mutantCell.mutant = mutant;
          rows[j].push(mutantCell);
          j++;
        }
      }
    }

    for (const row of Array.from(rows)) {
      while (row.length < i) {
        row.push(null);
      }
    }

    return rows;
  };

  renderClickableCell = (
    original: StandardDNACodon,
    mutated: StandardDNACodon,
    index: number,
    i: number,
    isCoding: boolean
  ): JSX.Element => (
    <td
      key={`${mutated}-${i}`}
      className={classNames({
        'u-background-active': this.isSelected(mutated, i),
        'u-pointer': true,
        'text-center': isCoding,
      })}
      onClick={HRTemplateActions.setMutatedBases.bind(null, this.props.sequence.id, i, mutated)}
    >
      <div>{highlightMutant(original, mutated, index, this.props.targetSite, this.props.pam)}</div>
      {isCoding ? (
        <div className="u-small-text">
          {__guard__(this.usageScore(mutated), (x: number): string => x.toFixed(2))}
        </div>
      ) : undefined}
    </td>
  );

  renderIntronInputCell = (original: StandardDNACodon, mutated: StandardDNACodon, i: number): JSX.Element => (
    <td
      key={`input-cell-${i}`}
      className={classNames({
        'u-background-active': !this.isSelected(original, i),
      })}
    >
      <input
        type="text"
        value={mutated}
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        onChange={(e) => HRTemplateActions.setMutatedBases(this.props.sequence.id, i, e.target.value)}
      />
    </td>
  );

  setSelectionEndpoints = (start: number, end: number): void => {
    this.props.sequence.selection().setEndpoints(start, end);
    this.props.sequence.trigger('jump', start);
  };

  override render(): JSX.Element {
    let mutantRows: Array<Array<HRTemplateColumn | null>>;
    let i;
    return (
      <table className="table table-bordered table-condensed table-valign-middle-cells">
        <thead>
          <tr>
            <th>{null}</th>
            {/* eslint-disable-next-line no-restricted-syntax */}
            {_.map(this.props.columns, ({start, end, isCoding}, i) => (
              <th
                key={`column-header-${i}`}
                onClick={this.setSelectionEndpoints.bind(this, start, end)}
                className={classNames({
                  'text-center mono': isCoding,
                  'u-normal-font-weight': true,
                })}
              >
                <a>
                  {isCoding
                    ? util.translateOnStrand(
                        this.props.sequence.residueSlice(start, end),
                        1,
                        this.props.sequence.nucleotideType(),
                        CodonTranslationTable.STANDARD,
                        false
                      )
                    : 'Non-coding'}
                </a>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Wildtype</th>
            {/* eslint-disable-next-line no-restricted-syntax */}
            {_.map(this.props.columns, ({start, end, isCoding}, i) => {
              const bases = this.props.sequence.residueSlice(start, end) as StandardDNACodon;
              return this.renderClickableCell(bases, bases, start, i, isCoding);
            })}
          </tr>
          {Array.from((mutantRows = this.mutantRows(this.props.columns))).map((row, j) => (
            <tr key={`mutant-row-${j}`}>
              {j === 0 ? (
                <th rowSpan={mutantRows.length}>
                  Mutations
                  <Tooltip title="Reset to Defaults" container="body">
                    <a
                      className="u-tiny-spacing-left"
                      onClick={HRTemplateActions.suggestMutations.bind(null, this.props.sequence.id)}
                    >
                      <BenchlingIcon icon="undo" />
                    </a>
                  </Tooltip>
                </th>
              ) : undefined}
              {(() => {
                const result = [];
                for (i = 0; i < row.length; i++) {
                  const cell = row[i];
                  if (cell != null) {
                    const {start, end, mutant, mutated, isCoding} = cell;
                    if (isCoding) {
                      result.push(
                        this.renderClickableCell(
                          this.props.sequence.residueSlice(start, end) as StandardDNACodon,
                          mutant!,
                          start,
                          i,
                          isCoding
                        )
                      );
                    } else {
                      result.push(
                        this.renderIntronInputCell(
                          this.props.sequence.residueSlice(start, end) as StandardDNACodon,
                          mutated!,
                          i
                        )
                      );
                    }
                  } else if (j === 0 || mutantRows[j - 1][i] != null) {
                    result.push(
                      <td key={`empty-${i}-${j}`} rowSpan={mutantRows.length - j}>
                        {null}
                      </td>
                    );
                  } else {
                    result.push(undefined);
                  }
                }
                return result;
              })()}
            </tr>
          ))}
          <tr>
            <th>Final</th>
            {/* eslint-disable-next-line no-restricted-syntax */}
            {_.map(this.props.columns, ({start, end, mutated, isCoding}, i) => (
              <td key={`mutated-bases-${i}`} className={classNames({'text-center': isCoding})}>
                {highlightMutant(
                  this.props.sequence.residueSlice(start, end),
                  mutated,
                  start,
                  this.props.targetSite,
                  this.props.pam
                )}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    );
  }
}

export default MutantTable;

function __guard__<T, V>(value: Optional<T>, transform: (t: T) => V): V | undefined {
  return value != null ? transform(value) : undefined;
}
